import { useRef, useEffect } from "react"

export default () => {
  const targetRef = useRef(null)

  const focusTarget = () => {
    if (document.activeElement === document.body) {
      // The target element needs a tabindex of -1 to reliably set focus using JavaScript
      // https://allyjs.io/data-tables/focusable.html
      targetRef.current?.focus()
    }
  }

  useEffect(() => {
    window.addEventListener("keypress", focusTarget)
    targetRef.current?.focus()
    return () => {
      window.removeEventListener("keypress", focusTarget)
    }
  }, [])

  return targetRef
}
